import { render, staticRenderFns } from "./TeamSettings.vue?vue&type=template&id=6825e084&"
import script from "./TeamSettings.vue?vue&type=script&lang=js&"
export * from "./TeamSettings.vue?vue&type=script&lang=js&"
import style0 from "./TeamSettings.vue?vue&type=style&index=0&id=6825e084&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports